export { default as About } from './About';
export { default as Footer } from './Footer';
export { default as Hero } from './Hero';
export { default as Journey } from './Journey';
export { default as Navbar } from './Navbar';
export { default as Pricing } from './Pricing';
export { default as Seats } from './Seats';
